/*
 * Container for the actual table filters
 */
import React from 'react'

const FiltersAccordion = ({ expanded, children }) => {
  return (
    <div className='w-100'>
      <div className={expanded ? 'filters-accordion-expanded' : 'd-none'}>
        {children}
      </div>
    </div>
  )
}

export default FiltersAccordion
